export const en = {
    bannersNo: 'Ad',
    changedParameter: 'Changed parameter',
    changedValue: 'What changed',
    cid: 'Campaign',
    date: 'Date and Time',
    groupNo: 'Group',
    'moscow-time': 'Moscow Time',
    number: '№',
    userName: 'Changed by'
};
